import moment from 'moment';
import { getRoomOption } from '../../room';
import { getLocalID } from '../local';
import { MiddlewareRegistry } from '../redux';
import { isChatOpend } from '../sidebar';
import { OPEN_CHAT, TOGGLE_HIDE_CHAT } from '../sidebar/actionTypes';
import { addMessageList, setIsChatRead, setIsLive } from './action';
import { ADD_FILE_MESSAGE, ADD_MESSAGE } from './actionTypes';
import { checkChatPermission, getIsLive, getMessageByUid } from './functions';
import { SET_DUAL_MONITOR } from '../../video-layout/actionTypes';
import { getApiChatSize } from './constants';
const renderChatList = (store, timestamp, isUp, isFirst) => {
    const local = getLocalID(store.getState());
    store.dispatch(setIsChatRead(true));
    const uuid = getRoomOption(store.getState()).uuid;
    const creationTime = timestamp ? moment(timestamp).toISOString() : moment().toISOString();
    let apiUrl = null;
    if (isUp) {
        apiUrl = `/api/meeting/v1/meetings/${uuid}/chat-logs?limit=${getApiChatSize()}&creation_time_lt=${encodeURIComponent(creationTime)}&orderby=${encodeURIComponent('creation_time DESC')}`;
    }
    else {
        isFirst;
        apiUrl = `/api/meeting/v1/meetings/${uuid}/chat-logs?limit=${getApiChatSize()}&creation_time_gte=${encodeURIComponent(creationTime)}&orderby=${encodeURIComponent('creation_time')}`;
    }
    apiUrl &&
        fetch(apiUrl)
            .then(response => {
            // 5xx HTML 응답을 json() 하면 SyntaxError — ok 가드
            if (!response.ok)
                throw new Error(`chat-logs ${response.status}`);
            return response.json();
        })
            .then(data => {
            if (data.result) {
                const { count_in_meeting_group, items, total_count } = data.result;
                let messages = [];
                if (items) {
                    items.forEach((item) => {
                        const timestamp = new Date(item.creation_time).getTime();
                        messages.push({
                            uuid: timestamp.toString() + "_" + item.from_user_id,
                            type: item.type,
                            from: item.from_member_id,
                            isMe: local === item.from_user_id ? true : false,
                            fromNickname: item.from_nicknams,
                            fromRole: item.from_role,
                            message: item.message,
                            privateMessage: undefined,
                            timestamp,
                            // .format(militaryTime ? 'HH:mm' : 'LT'),
                        });
                    });
                }
                // ★늦은 위로-페이지 응답 가드: 응답이 도착하기 전에 사용자가 이미 바닥으로
                // 복귀(live)했다면 병합하지 않는다 — 과거 페이지가 최신 윈도우를 트림하고
                // isLive 를 되돌려 "바닥인데 최근 메시지가 사라지는" 역전을 막는다.
                // 폐기해도 사용자가 다시 위로 올리면 자연 재요청된다.
                if (isUp && !isFirst && getIsLive(store.getState)) {
                    // discarded: 병합 없이 폐기 — 스크롤 컨테이너가 stale 복원 스냅샷을 정리하도록 표시
                    APP.eventManager.publish('CHAT_HISTORY_SETTLED', { isUp, isFirst, count: messages.length, discarded: true });
                    return;
                }
                store.dispatch(addMessageList(messages, count_in_meeting_group, isFirst ? messages[messages.length - 1] : null, isUp, isFirst));
                if (isUp && !isFirst) {
                    store.dispatch(setIsLive(false));
                }
                if (!isUp && total_count === 0) {
                    store.dispatch(setIsLive(true));
                }
                if (isFirst) {
                    store.dispatch(setIsLive(true));
                }
                // 로드 완료 신호 — 스크롤 컨테이너가 잠금 해제/최상단 도달 판정에 사용
                APP.eventManager.publish('CHAT_HISTORY_SETTLED', { isUp, isFirst, count: messages.length });
            }
            else {
                // result-falsy(서버 소프트 에러)는 "빈 페이지(히스토리 끝)"가 아니다 —
                // count 0 으로 보내면 reachedOldest 오판으로 재요청이 차단되므로 실패(-1)로 구분
                APP.eventManager.publish('CHAT_HISTORY_SETTLED', { isUp, isFirst, count: -1 });
            }
        })
            .catch(err => {
            // 채팅 패널 오픈 자체는 이 fetch 와 무관하게 진행된다 — 실패는 로그만 남기고
            // unhandledrejection(무통보 죽음)을 막는다. 과거 메시지는 다음 스크롤/재열기에서 재시도.
            console.error('renderChatList(chat-logs) 실패:', err);
            APP.eventManager.publish('CHAT_HISTORY_SETTLED', { isUp, isFirst, count: -1 });
        });
};
MiddlewareRegistry.register(store => next => async (action) => {
    switch (action.type) {
        case OPEN_CHAT:
            if (isChatOpend(store.getState()))
                return next(action);
            renderChatList(store, null, true, true);
            break;
        case 'UPDATE_DUAL_SIDE_OPEN':
        case SET_DUAL_MONITOR:
            renderChatList(store, null, true, true);
            break;
        case TOGGLE_HIDE_CHAT:
            if (!action.isHide) {
                renderChatList(store, null, true, true);
            }
            break;
        case 'UPDATE_BEFORE_CHAT':
            const top_item_timestamp = getMessageByUid(store.getState, action.lastItemId)?.timestamp;
            // @ts-ignore
            top_item_timestamp && renderChatList(store, top_item_timestamp, true, false);
            break;
        case 'REFETCH_LATEST_CHAT':
            // 윈도우 슬라이드 후 바닥 복귀 — 서버 기준 최신 페이지로 전면 교체(isFirst)
            renderChatList(store, null, true, true);
            break;
        case 'UPDATE_AFTER_CHAT':
            const bottom_item_timestamp = getMessageByUid(store.getState, action.startItemId)?.timestamp;
            const add1 = bottom_item_timestamp ? bottom_item_timestamp + 1 : null;
            // @ts-ignore
            bottom_item_timestamp && renderChatList(store, add1, false, false);
            break;
        case ADD_MESSAGE:
            let message = undefined;
            if (action.local) {
                const timestamp = new Date().getTime();
                message = {
                    uuid: timestamp.toString() + "_" + action.local.user_uuid,
                    type: 'text',
                    isMe: true,
                    from: action.local.user_uuid,
                    fromNickname: action.local.nickname,
                    fromRole: action.local.role,
                    message: action.message,
                    privateMessage: undefined,
                    timestamp,
                };
                if (action.isShared && message) {
                    if (checkChatPermission(store.getState, 'chat')) {
                        const response = await APP.management.sendMessage({ ...message, isMe: false });
                        if (response.status !== 200) {
                            APP.UI.alertMessage('채팅 전송 실패했습니다. 네트워크 확인해주세요.');
                            return;
                        }
                    }
                    else
                        return;
                }
            }
            else {
                message = {
                    ...action.message,
                };
            }
            if (!message)
                break;
            return next({
                ...action,
                message,
            });
        case ADD_FILE_MESSAGE:
            let fileMessage = undefined;
            if (action.local) {
                const file = action.message;
                const timestamp = new Date().getTime();
                const uuid = timestamp.toString() + "_" + action.local.user_uuid;
                fileMessage = {
                    uuid: uuid,
                    type: 'file',
                    isMe: true,
                    from: action.local.user_uuid,
                    fromNickname: action.local.nickname,
                    fromRole: action.local.role,
                    message: action.message.name,
                    privateMessage: undefined,
                    timestamp,
                };
                if (action.isShared && fileMessage) {
                    next({ type: ADD_MESSAGE, message: fileMessage });
                }
                const response = await APP.API.convertChatFile(file);
                if (response.complete) {
                    fileMessage = {
                        ...fileMessage,
                        message: JSON.stringify({
                            fileId: uuid,
                            name: fileMessage.message,
                            size: file.size,
                            link: response.data.download_link,
                        }),
                    };
                    if (action.isShared && fileMessage) {
                        if (checkChatPermission(store.getState, 'chat')) {
                            const response = await APP.management.sendMessage({ ...fileMessage, isMe: false });
                            if (response.status !== 200) {
                                APP.UI.alertMessage('채팅 전송 실패했습니다. 네트워크 확인해주세요.');
                                return;
                            }
                        }
                        else
                            return;
                    }
                }
            }
            else {
                fileMessage = {
                    ...action.message,
                };
            }
            if (!fileMessage)
                break;
            return next({
                ...action,
                type: ADD_MESSAGE,
                message: fileMessage,
            });
    }
    return next(action);
});
